module.exports = __webpack_public_path__ + "img/10.cddf35ca.jpg";